import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route';
import {
	CONTAINER_ADMIN_HOME_ID,
	CONTAINER_HOME_ID,
} from '@confluence/app-navigation/entry-points/navigationIDs';
import { ManagePagesLoader } from '@confluence/manage-pages/entry-points/ManagePagesLoader';
import { isCompanyHubSpaceKey } from '@confluence/route-manager/entry-points/companyHubUtils';
import { DocumentContentTitle } from '@confluence/document-title/entry-points/DocumentContentTitle';
import { NotFound } from '@confluence/not-found/entry-points/NotFound';

import SpaceBase from '../../SpaceBase';

export const SpaceBulkToolsRoute = ({ params: { spaceKey } }: RouteMatch) => {
	if (isCompanyHubSpaceKey(spaceKey)) {
		return (
			<>
				<DocumentContentTitle notFound />
				<NotFound />
			</>
		);
	}

	return (
		<SpaceBase>
			<ManagePagesLoader spaceKey={spaceKey} />
		</SpaceBase>
	);
};

SpaceBulkToolsRoute.NAVIGATION_PARAMS = (
	{ name, params: { spaceKey } }: RouteMatch,
	isNav4Enabled: boolean,
) => ({
	Screen: {
		screenEvent: { name: 'spaceBulkTools', id: spaceKey },
		pageState: { routeName: name, spaceKey },
	},
	MainLayout: {
		navView: isNav4Enabled ? CONTAINER_ADMIN_HOME_ID : CONTAINER_HOME_ID,
		spaceKey,
	},
});
